export const blurSrc = (src) => src.replace(/\.webp$/, "-blur.webp");

export const FrostLayer = ({ src, height = "50%" }) => (
  <div className="frost" style={{ "--blur-h": height }} aria-hidden>
    <img src={blurSrc(src)} alt="" loading="lazy" decoding="async" width="120" height="179" className="frost-img" />
    <span className="frost-tint" />
    <span className="frost-grain" />
    <span className="frost-edge" />
  </div>
);
